<template>
  <div class="ocpc-record-box">
    <a-table
      :columns="setListColumns"
      :data-source="setListTableDatas"
      :pagination="false"
      :loading="false"
    >
      <div
        slot="type"
        slot-scope="text"
      >
        {{ channelType[text - 1] }}
      </div>
      <div
        slot="status"
        slot-scope="text, record"
        class="status-type"
        :class="{'suc-status' : text * 1 === 1 && !!record.token}"
      >
        {{ statusTypeTxt(record) }}
      </div>
      <div
        slot="operate"
        slot-scope="text,record"
      >
        <a
          href="javascript:;"
          @click="toSetOcpc(record)"
        >{{ $t('message["1008"]') }}</a>
      </div>
    </a-table>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  data () {
    return {
      stopTips: [this.$t('message["1839"]'), this.$t('message["1841"]'), this.$t('message["1861"]')], // 停用提示语
      failTips: [this.$t('message["1840"]'), this.$t('message["1884"]'), this.$t('message["1843"]')] // 未设置授权时的提示语
    }
  },
  computed: {
    ...mapState('config/ocpc', ['setListColumns', 'isRecordDataReady', 'setlisttabledatas', 'channelType']),
    ...mapGetters('config/ocpc', ['setListTableDatas'])
  },
  async created () {
    await this.getOcpcSetListDatas()
    if (this.isRecordDataReady) {
      const { projectname = '', comname = '' } = this.$store.state.baseinfo
      document.title = 'oCPC' + `- ${projectname} - ${comname}`
    }
  },
  methods: {
    ...mapActions('config/ocpc', ['getOcpcSetListDatas']),
    toSetOcpc (record) {
      this.$router.push({ name: 'setOcpc', query: { type: record.type } })
    },
    // 提示文案
    statusTypeTxt (record) {
      let txt = ''
      const { status = 0, token = '' } = record
      // 类型 type 1: 百度 2:谷歌 3:yandex
      const type = record.type * 1 - 1
      if (status === 1) { // 开启状态
        txt = !token ? this.failTips[type] : this.$t('message["1466"]')
      } else if (status === 0) { // 未设置授权状态
        txt = this.failTips[type]
      } else if (status === 2) { // 停用状态
        txt = this.stopTips[type]
      }
      return txt
    }
  }
}
</script>
<style lang="scss" scoped>
.suc-status{
    color: #42C27E;
  }
</style>
